import { useEffect, useState } from "react";
import api from "./api";

export const DEFAULT_CONTENT = {
  founder_name: "[Your name]",
  founder_note:
    "Every lunch break the arguments about last night's match are louder than the bell — yet our school pitch sits empty most evenings. Some of us play every week, others only ever watch. So I stopped guessing and started asking: surveys, polls, and proper conversations. This website is where the research lives.",
  contact_phone: "[add your number in the Owner's room]",
  contact_email: "sidelines.research@example.com",
  contact_instagram: "@sidelines.research",
  contact_location: "Morbi — ask at school",
  talk_intro:
    "Got a story about football in Morbi? Disagree with a poll result? Want the findings for your team, school or club? My number's right here — or drop me a message below. Parents and teachers very welcome.",
};

let cache = null;
let pending = null;

export default function useContent() {
  const [content, setContent] = useState(cache);

  useEffect(() => {
    if (cache) return;
    if (!pending) {
      pending = api
        .get("/content")
        .then((r) => {
          cache = { ...DEFAULT_CONTENT, ...r.data };
          return cache;
        })
        .catch(() => {
          cache = { ...DEFAULT_CONTENT };
          return cache;
        });
    }
    pending.then((c) => setContent(c));
  }, []);

  return content || DEFAULT_CONTENT;
}
